import {IHttpService} from "angular";
import {Simulation} from "../models/Simulation";
import {
    NewSimulationRecord,
    SimulationCalculationResultRecord,
    SimulationRecord, sortByCreatedAsc
} from "../models/TradeSimulationRecords";
import {Optional} from "../../js/util/Optional";

export class TradeSimulationService {

    public static id = "tradeSimulationService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {
    }

    public async list(): Promise<Array<SimulationRecord>> {
        const response = await this.$http.get<Array<SimulationRecord>>("/tradefloor/api/simulation");
        return Optional.of(response)
                       .map(res => res.data)
                       .map(data => data.sort(sortByCreatedAsc()))
                       .orElse([]);
    }

    public async create(simulation: NewSimulationRecord): Promise<number> {
        const response = await this.$http.post<number>("/tradefloor/api/simulation", simulation);
        return +response.data!;
    }

    public async update(simulation: Simulation): Promise<void> {
        const record = simulation.toRecord();
        await this.$http.put(`/tradefloor/api/simulation/${simulation.id}`, record);
    }

    public async delete(id: number): Promise<void> {
        await this.$http.delete(`/tradefloor/api/simulation/${id}`);
    }

    public async  deleteAll(): Promise<void> {
        await this.$http.delete(`/tradefloor/api/simulation`);
    }

    public async calculate(simulation: Simulation): Promise<SimulationCalculationResultRecord> {
        const record = simulation.toRecord();
        const url = "/tradefloor/api/simulation-calculation";
        const response = await this.$http.post<SimulationCalculationResultRecord>(url, record);
        return response.data!;
    }
}
